import {
  ImageType,
  ProductColorOptionsGrid,
  ProductColorOptionsProps,
} from '@aboutyou/ui-components';
import React from 'react';

interface ProductSelectionGridProps {
  className?: string;
  colorOptions: ProductColorOptionsProps['options'];
  disablePreviewImage?: boolean;
  uniqueKey?: string;
  setPreviewImage?: (previewImage?: ImageType) => void;
  setImageGridInactive?: (isActive: boolean) => void;
}

export const ProductSelectionGrid: React.FC<ProductSelectionGridProps> = ({
  className,
  colorOptions,
  disablePreviewImage,
  uniqueKey,
  setPreviewImage,
  setImageGridInactive,
}) => {
  return (
    <ProductColorOptionsGrid
      data-testid="productColorOptions"
      className={className}
      uniqueKey={uniqueKey}
      disablePreviewImage={disablePreviewImage}
      colorOptions={colorOptions}
      setPreviewImage={setPreviewImage}
      setImageGridInactive={setImageGridInactive}
    />
  );
};
